module.exports = __webpack_public_path__ + "static/media/kråka.3d0607a6.mp3";